import compatibility from "../../../pictures/home/screens/compatibility.jpg";
import discover from "../../../pictures/home/screens/discover.jpg";
import chats from "../../../pictures/home/screens/chats.jpg";
import privateChat from "../../../pictures/home/screens/private-chat.jpg";
import privacy from "../../../pictures/home/screens/privacy-settings.jpg";
import profile from "../../../pictures/home/screens/profile-menu.jpg";
import guidance from "../../../pictures/home/screens/islamic-guidance.jpg";
import islamicShorts from "../../../pictures/home/screens/islamic-shorts.jpg";
import chatsDark from "../../../pictures/home/screens/chats-dark.jpg";
import filtersDark from "../../../pictures/home/screens/filters-dark.jpg";

/** App screenshots shown across the homepage. `alt` is a key in the site translations. */
export const SCREENS = {
  compatibility: { src: compatibility, alt: "screens.compatibility" },
  discover: { src: discover, alt: "screens.discover" },
  chats: { src: chats, alt: "screens.chats" },
  privateChat: { src: privateChat, alt: "screens.privateChat" },
  privacy: { src: privacy, alt: "screens.privacy" },
  profile: { src: profile, alt: "screens.profile" },
  guidance: { src: guidance, alt: "screens.guidance" },
  shorts: { src: islamicShorts, alt: "screens.shorts" },
  chatsDark: { src: chatsDark, alt: "screens.chatsDark" },
  filtersDark: { src: filtersDark, alt: "screens.filtersDark" },
};
